/*
* Dropdrown 
*/
/*
* Matt Rajout animation sur le contenu
*/
let $dropdownItems = document.querySelectorAll('.icons-dropdown__item');
$dropdownItems.forEach(item => {
  item.addEventListener('click', function () {
    // console.log(this);

    if (this.classList.contains('active')) {
      this.classList.remove('active');
      document.querySelectorAll(".icons-dropdown__drop-content").forEach((el) => {
        slideUp(el, 500);
      });      
    } else {
      let $activeItem = document.querySelector('.icons-dropdown__item.active');

      if ($activeItem != null) {
        $activeItem.classList.remove('active');
        document.querySelectorAll(".icons-dropdown__drop-content").forEach((el) => {
          slideUp(el, 500);
        });        
      }

      this.classList.add('active');
      document.querySelectorAll(".active .icons-dropdown__drop-content").forEach((el) => {
        slideDown(el, 500);
      });
    }
  });
});

function slideUp(element, duration = 500) {
  element.style.transitionProperty = "height, margin, padding";
  element.style.transitionDuration = duration + "ms";
  element.style.boxSizing = "border-box";
  element.style.height = element.offsetHeight + "px";
  element.offsetHeight; // force repaint
  element.style.overflow = "hidden";
  element.style.height = 0;
  element.style.paddingTop = 0;
  element.style.paddingBottom = 0;
  element.style.marginTop = 0;
  element.style.marginBottom = 0;

  window.setTimeout(() => {
    element.style.display = "none";
    element.style.removeProperty("height");
    element.style.removeProperty("padding-top");
    element.style.removeProperty("padding-bottom");
    element.style.removeProperty("margin-top");
    element.style.removeProperty("margin-bottom");
    element.style.removeProperty("overflow");
    element.style.removeProperty("transition-duration");
    element.style.removeProperty("transition-property");
  }, duration);
}

function slideDown(element, duration = 500) {
  element.style.removeProperty("display");
  let display = window.getComputedStyle(element).display;
  if (display === "none") display = "block";
  element.style.display = display;

  let height = element.offsetHeight;
  element.style.overflow = "hidden";
  element.style.height = 0;
  element.style.paddingTop = 0;
  element.style.paddingBottom = 0;
  element.style.marginTop = 0;
  element.style.marginBottom = 0;
  element.offsetHeight; // force repaint
  element.style.transitionProperty = "height, margin, padding";
  element.style.transitionDuration = duration + "ms";
  element.style.height = height + "px";
  element.style.removeProperty("padding-top");
  element.style.removeProperty("padding-bottom");
  element.style.removeProperty("margin-top");
  element.style.removeProperty("margin-bottom");

  window.setTimeout(() => {
    element.style.removeProperty("height");
    element.style.removeProperty("overflow");
    element.style.removeProperty("transition-duration");
    element.style.removeProperty("transition-property");
  }, duration);
}
